<template>
	<div class="__side-menu">
		<div class="__wrapper">
			<div
				class="__side-menu__header p-6 pr-0 uppercase flex justify-between items-center text-neutral-400 text-xs font-semibold"
			>
				<div>Cơ sở giáo dục</div>
				<div
					class="h-10 w-10 flex items-center justify-end cursor-pointer"
					@click="$emit('choose')"
				>
					<DaIcon class="cursor-pointer w-1" name="das--ellipsis" />
				</div>
			</div>
			<div class="__side-menu__content">
				<div class="__side-menu__brand p-6 flex items-center">
					<div>
						<img
							v-if="profile?.current_org?.profile_photo?.w200"
							:src="profile?.current_org?.profile_photo?.w200"
							alt=""
							class="shadow-sm inline-block h-10 w-10 rounded-md"
						/>
						<span
							v-else
							:style="{
								background:
									profile?.current_org?.profile_photo?.default
										?.color,
							}"
							class="shadow-sm inline-flex items-center justify-center h-10 w-10 rounded-xl"
						>
							<span class="font-medium leading-none text-white">{{
								profile?.current_org?.profile_photo?.default
									?.initial
							}}</span>
						</span>
					</div>
					<div class="ml-4 font-semibold text-neutral-600 w-32">
						<div v-if="profile?.current_org?.name">
							{{ profile?.current_org?.name }}
						</div>
						<div v-else>Tên trung tâm</div>
					</div>
				</div>
				<div class="__side-menu__menu">
					<div class="__menu__group">
						<div
							v-for="item in menu"
							:key="item.id"
							class="__menu__wrapper mb-1"
						>
							<template v-if="item.vIf">
								<component
									:is="
										menuItemLink(item)
											? 'router-link'
											: 'div'
									"
									v-if="
										!item.guard ||
										(item.guard.includes(
											profile?.staff?.role
										) &&
											(item.flag === undefined ||
												item.flag === true))
									"
									:to="menuItemLink(item) || undefined"
								>
									<div
										:class="[
											isMenuGroupLocked(item) &&
											haveSub(item.subs)
												? 'side-menu--active'
												: haveSub(item.subs)
												? 'text-yellow-700'
												: '',
											checkState(item.state)
												? 'grey-out'
												: '',
										]"
										class="__menu__item pl-6 pr-1 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"
										:data-tour-id="
											item.id === 'record'
												? 'tour-menu-record'
												: undefined
										"
										@click="onMenuItemClick(item)"
									>
										<div
											class="flex flex-nowrap items-center"
										>
											<div>
												<DaIcon
													:name="item.icon"
													class="w-4"
												/>
											</div>
											<div
												class="font-semibold ml-3"
												style="font-size: 14px"
											>
												{{ item.name }}
											</div>
											<img
												v-if="item.id === 'lucahub'"
												class="h-4 w-auto ml-2"
												src="@/assets/images/illustrations/lucahub.png"
												alt=""
											/>
										</div>
										<div
											v-if="visibleSubs(item).length"
											class="cursor-pointer"
											@click.stop="subOpen(item.id)"
										>
											<DaIcon
												:class="[
													isSubExpanded(item)
														? 'rotate-180'
														: '',
												]"
												class="h-4 w-4 transform arrow--icon-menu"
												name="das--chevron-down"
											/>
										</div>
									</div>
								</component>
								<template v-if="visibleSubs(item).length">
									<div
										v-show="isSubExpanded(item)"
										class="__side-menu__subs"
										@click.stop
									>
										<template
											v-for="s in visibleSubs(item)"
											:key="s.id"
										>
											<router-link
												v-if="
													s.scheduleKind &&
													canShowMenuItem(s)
												"
												v-slot="{ href, navigate }"
												:to="s.link"
												custom
											>
												<a
													:href="href"
													:class="
														scheduleMenuActive(
															s.scheduleKind
														)
															? 'router-link-exact-active'
															: ''
													"
													@click.stop="navigate"
												>
													<div
														class="__menu__sub px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"
														:class="
															checkState(s.state)
																? 'grey-out'
																: ''
														"
													>
														<div
															class="flex flex-nowrap items-center"
														>
															<div
																class="w-4"
															></div>
															<div
																class="font-semibold ml-3"
																style="
																	font-size: 14px;
																"
															>
																{{ s.name }}
															</div>
														</div>
													</div>
												</a>
											</router-link>
											<router-link
												v-else-if="canShowMenuItem(s)"
												:class="
													isSubActive.includes(s?.id)
														? 'router-link-active'
														: ''
												"
												:to="s.link"
												@click.stop
											>
												<div
													:class="[
														s.id === '2'
															? 'side-menu--active'
															: '',
														checkState(s.state)
															? 'grey-out'
															: '',
													]"
													class="__menu__sub px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"
													:data-tour-id="
														s.id ===
															'record_student' ||
														s.id ===
															'record_employee' ||
														s.id === 'plans_data'
															? `tour-menu-${s.id}`
															: undefined
													"
													@click="onSubMenuClick(s)"
												>
													<div
														class="flex flex-nowrap items-center"
													>
														<div class="w-4"></div>
														<div
															class="font-semibold ml-3"
															style="
																font-size: 14px;
															"
														>
															{{ s.name }}
														</div>
														<img
															v-if="
																(s.id ===
																	'record_student' &&
																	hasStudentsNeedGeneratePeriodReport) ||
																(s.id ===
																	'packages' &&
																	isCenterExpiredOrLocked)
															"
															src="@/assets/images/icons/warning-fill.png"
															alt=""
															class="w-4 h-4 ml-2 object-contain flex-shrink-0"
														/>
													</div>
												</div>
											</router-link>
										</template>
									</div>
								</template>
							</template>
						</div>
					</div>

					<div
						class="line bg-neutral-200 block mx-auto mb-10"
						style="height: 1px; width: 200px"
					></div>
					<div class="px-6 pb-2 font-semibold text-neutral-500">
						Cá nhân
					</div>
					<div class="__menu__group">
						<div class="__menu__wrapper mb-1">
							<div
								:class="
									$route.fullPath == '/profile'
										? 'side-menu--active'
										: ''
								"
								class="__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"
								@click="$router.push('/profile')"
							>
								<div class="flex flex-nowrap items-center">
									<div>
										<img
											v-if="
												profile?.staff?.profile_photo
													?.w200
											"
											:src="
												profile?.staff?.profile_photo
													?.w200
											"
											alt=""
											class="shadow-sm inline-block h-10 w-10 rounded-full"
										/>
										<span
											v-else
											:style="{
												background:
													profile?.staff
														?.profile_photo?.default
														?.color,
											}"
											class="inline-flex items-center justify-center h-10 w-10 rounded-full"
										>
											<span
												class="font-medium leading-none text-white text-lg"
												>{{
													profile?.staff
														?.profile_photo?.default
														?.initial
												}}</span
											>
										</span>
									</div>
									<div
										class="font-semibold ml-3"
										style="font-size: 14px"
									>
										<div v-if="profile?.staff?.name">
											{{ profile?.staff?.name }}
										</div>
										<div v-else>Xin chào</div>
										<div class="font-normal text-xs">
											{{
												$filters.role(
													profile?.staff?.role
												)
											}}
										</div>
									</div>
								</div>
							</div>
							<div
								class="__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"
								@click="$emit('logout')"
							>
								<div class="flex flex-nowrap items-center">
									<div>
										<DaIcon class="w-4" name="das--out" />
									</div>
									<div
										class="font-semibold ml-3"
										style="font-size: 14px"
									>
										Đăng xuất
									</div>
								</div>
							</div>
							<a
								class="__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"
								href="https://wiki.luca.education/cac-ban-cap-nhat/website"
								target="_blank"
								rel="noopener noreferrer"
							>
								<div class="flex flex-nowrap items-center">
									<div>
										<img
											alt=""
											class="w-4 h-4"
											src="@/assets/images/icons/bulb.png"
										/>
									</div>
									<div
										class="font-semibold ml-3"
										style="font-size: 14px; color: #e5a42b"
									>
										Tìm hiểu tính năng mới
									</div>
								</div>
							</a>
							<!-- <div
								class="
									__menu__item
									px-6
									py-4
									cursor-pointer
									text-neutral-500
									flex flex-nowrap
									items-center
									gap-3
									relative
								"
								@click="open = !open"
							>
								<img
									:src="
										require(`@/assets/images/illustrations/${language.flag}.png`)
									"
									alt=""
								/>
								<div>{{ language.name }}</div>
								<img
									alt=""
									src="@/assets/images/illustrations/open-menu.png"
								/>
								<div v-if="open" class="select-block">
									<div
										v-for="i in languages"
										:key="i.name"
										class="
											flex
											items-center
											gap-3
											px-4
											py-2
											h-9
											hover:bg-yellow-100
										"
										@click="changeLanguage(i)"
									>
										<img
											:src="
												require(`@/assets/images/illustrations/${i.flag}.png`)
											"
										/>
										<div>{{ i.name }}</div>
									</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, setup, Vue } from 'vue-class-component';
import { computed, watch } from 'vue';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { useStore } from 'vuex';
import { Watch } from 'vue-property-decorator';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import ChooseCenter from '@/components/elements/chooseCenter/ChooseCenter.vue';
import { _ROUTER_NAME } from '@/enums';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { useTutorial } from '@/features/tutorial/useTutorial';
import { isScheduleMenuActive } from '@/helper/scheduleSection';
import { getLiteLockedFeature, isLitePackage } from '@/helper/packageTier';

@Options({
	name: 'SideMenu',
	components: { ChooseCenter, DaModalFrame, DaIcon },
})
export default class SideMenu extends Vue {
	//----------------------- 🤍 Data 🤍 -----------------------//
	isSubOpen = '';
	isSubActive = '';
	collapsedSubs = [];
	language = {
		name: 'VNI',
		flag: 'vni',
	};
	open = false;
	setup = setup(() => {
		const store = useStore();
		const tutorial = useTutorial();
		watch(
			() => tutorial.activeSpotlight.value?.targetId,
			(targetId) => {
				if (
					targetId === 'tour-menu-record' ||
					targetId === 'tour-menu-record_student' ||
					targetId === 'tour-menu-record_employee' ||
					targetId === 'tour-menu-plans_data'
				) {
					// expand via returning a flag consumed in component - handled in methods watch below
				}
			}
		);
		return {
			store,
			tutorialSpotlightTarget: computed(
				() => tutorial.activeSpotlight.value?.targetId
			),
		};
	});

	get menu() {
		return [
			{
				id: 'lucahub',
				name: 'Quản lý',
				icon: 'das--lucahub',
				link: '/luca-hub',
				menu: 'lucahub',
				guard: ['leader', 'support', 'org_admin', 'admin'],
				state: ['activated', 'community', 'expired'],
				isGuard: true,
				vIf: true,
			},
			{
				id: 'org',
				name: 'Quản lý hệ thống',
				icon: 'das--statics',
				menu: 'org',
				guard: ['leader', 'support', 'accountant', 'org_admin'],
				state: ['activated', 'expired', 'community'],
				vIf: !isLitePackage(this.profile),
				subs: [
					{
						id: 'dashboard-org',
						name: 'Thống kê Tổng quan',
						link: '/dashboard-org',
						isGuard: this.isShowHTCS,
						guard: ['leader', 'support'],
						state: ['activated', 'expired', 'community'],
					},
					{
						id: 'dashboard-stats-chart',
						name: 'Biểu đồ Thống kê',
						link: '/dashboard-stats-chart',
						isGuard: this.isShowHTCS,
						guard: ['leader', 'support'],
						state: ['activated', 'expired', 'community'],
					},
					{
						id: 'packages',
						name: 'Gói dịch vụ',
						link: '/packages',
						isGuard: true,
						guard: ['leader', 'support', 'accountant', 'org_admin'],
						state: ['activated', 'community', 'expired', 'locked'],
					},
				],
			},
			{
				id: 'home',
				name: 'Quản lý cơ sở',
				icon: 'das--home',
				menu: 'setup',
				guard: [
					'leader',
					'support',
					'admin',
					'org_admin',
					'accountant',
				],
				state: ['activated', 'community', 'expired'],
				vIf: true,
				subs: [
					{
						id: 'dashboard',
						name: 'Thống kê cơ sở',
						link: '/dashboard',
						isGuard: true,
						guard: ['leader', 'support', 'org_admin', 'admin'],
						state: ['activated', 'community', 'expired'],
					},
					...(isLitePackage(this.profile)
						? [
								{
									id: 'packages',
									name: 'Gói dịch vụ',
									link: '/packages',
									isGuard: true,
									guard: [
										'leader',
										'support',
										'accountant',
										'org_admin',
									],
									state: [
										'activated',
										'community',
										'expired',
										'locked',
									],
								},
						  ]
						: []),
					{
						id: 'fee_notices',
						name: 'Quản lý học phí',
						link: '/fee-notices',
						isGuard: true,
						guard: ['leader', 'support', 'org_admin', 'accountant'],
						state: ['activated', 'expired'],
					},
					{
						id: 'center-timetable',
						name: 'Thời khoá biểu',
						link: '/center-timetable',
						isGuard: true,
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated'],
					},
					{
						id: 'notification',
						name: 'Thông báo',
						icon: '',
						link: '/notifications',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community', 'expired'],
						isGuard: true,
					},
					// {
					// 	id: 'media_history',
					// 	name: 'Thư viện video',
					// 	icon: '',
					// 	link: '/media-history',
					// 	guard: ['leader', 'support', 'admin', 'org_admin'],
					// 	state: ['activated', 'community', 'expired'],
					// 	isGuard: true,
					// },
					{
						id: 'forms_evaluation',
						name: 'Biểu mẫu đánh giá',
						icon: '',
						link: '/form-evaluation',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'expired'],
						isGuard: true,
					},
					{
						id: 'holiday',
						name: 'Ngày nghỉ/lễ',
						icon: '',
						link: '/holiday',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community', 'expired'],
						isGuard: true,
					},
					{
						id: 'birthday',
						name: 'Sinh nhật',
						icon: '',
						link: '/birthdays',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community', 'expired'],
						isGuard: true,
					},
					{
						id: 'documents',
						name: 'Kho tài liệu',
						icon: '',
						link: '/documents',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community', 'expired'],
						isGuard: true,
					},
					{
						id: 'survey',
						name: 'Phiếu khảo sát',
						icon: '',
						link: '/survey',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'expired', 'community'],
						isGuard: true,
						flag: this.flagCheckSurvey(),
					},
					{
						id: 'documents',
						name: 'Kho tài liệu',
						icon: '',
						link: '/documents',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community', 'expired'],
						isGuard: true,
					},
				],
			},
			{
				id: 'record',
				name: 'Quản lý hồ sơ',
				icon: 'das--person',
				menu: 'record',
				isGuard: true,
				guard: [
					'leader',
					'support',
					'admin',
					'org_admin',
					'accountant',
					'teacher',
				],
				state: ['activated', 'community', 'expired'],
				vIf: true,
				subs: [
					{
						id: 'record_employee',
						name: 'Hồ sơ nhân sự',
						icon: '',
						link: '/record/employee',
						isGuard: true,
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'accountant',
						],
						state: ['activated', 'community', 'expired'],
					},
					{
						id: 'record_student',
						name: 'Hồ sơ học sinh',
						icon: '',
						link: '/record/student',
						isGuard: true,
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'accountant',
							'teacher',
						],
						state: ['activated', 'community', 'expired'],
					},
					{
						id: 'transferred_data',
						name: 'Hồ sơ chuyển cơ sở',
						icon: '',
						link: '/transferred-data',
						isGuard: true,
						state: ['activated', 'community', 'expired'],
						guard: ['leader', 'support', 'admin', 'org_admin'],
					},
				],
			},

			{
				id: 'filter_and_evaluate',
				name: 'Sàng lọc & đánh giá',
				icon: 'das--filter',
				menu: 'filter_and_evaluate',
				guard: [
					'leader',
					'support',
					'admin',
					'org_admin',
					'accountant',
				],
				state: ['activated', 'community', 'expired'],
				vIf: true,
				subs: [
					{
						id: 'filter',
						name: 'Sàng lọc',
						link: '/filter',
						isGuard: true,
						guard: ['leader', 'support', 'org_admin', 'admin'],
						state: ['activated', 'community', 'expired'],
					},
					{
						id: 'evaluate_development',
						name: 'Đánh giá phát triển',
						link: '/evaluate_development',
						isGuard: true,
						guard: ['leader', 'support', 'org_admin', 'admin'],
						state: ['activated', 'community', 'expired'],
					},
					{
						id: 'evaluate_process',
						name: 'Đánh giá quá trình CT',
						link: '/evaluate_process',
						isGuard: true,
						guard: ['leader', 'support', 'org_admin', 'admin'],
						state: ['activated', 'community', 'expired'],
					},
				],
			},
			{
				id: 'personal',
				name: 'Quản lý lớp cá nhân',
				icon: 'das--personal',
				menu: 'personal',
				isGuard: true,
				vIf: true,
				guard: ['leader', 'support', 'admin', 'org_admin', 'teacher'],
				state: ['activated', 'expired', 'community'],
				subs: [
					{
						id: 'plans_data',
						name: `${this.$filters.terminology('plan')}`,
						icon: '',
						link: '/plans',
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'community'],
						isGuard: true,
						vIf: true,
					},
					{
						id: 'report_lesson',
						name: 'Báo cáo cá nhân',
						icon: '',
						link: '/report/lesson',
						isGuard: true,
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'expired'],
					},
					{
						id: 'schedule_personal',
						name: 'Lịch học cá nhân',
						icon: '',
						link: '/schedule/timeslot',
						isGuard: true,
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated'],
						scheduleKind: 'personal',
					},
				],
			},
			{
				id: 'daycare_class',
				name: 'Quản lý lớp bán trú',
				icon: 'das--daycare',
				menu: 'daycare_class',
				isGuard: true,
				vIf: true,
				guard: ['leader', 'support', 'admin', 'org_admin', 'teacher'],
				state: ['activated', 'expired', 'community'],
				subs: [
					{
						id: 'daycare_class',
						name: 'Lớp bán trú',
						icon: '',
						link: '/daycare-class',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'expired', 'community'],
						isGuard: true,
					},
					{
						id: 'report_day-care',
						name: 'Báo cáo  bán trú',
						icon: '',
						link: '/report/day-care',
						isGuard:
							this.org_setting.has_day_care &&
							this.profile.exists_day_care_class,
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'expired'],
					},
					{
						id: 'menu',
						name: 'Thực đơn bán trú',
						icon: '',
						link: '/menu',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated'],
						isGuard: true,
						flag: true,
					},
					{
						id: 'schedule_daycare',
						name: 'Lịch học bán trú',
						icon: '',
						link: '/schedule/timeslot/daycare',
						isGuard:
							this.org_setting.has_day_care &&
							this.org_setting.enable_day_care_class_schedule &&
							this.profile.exists_day_care_class,
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated'],
						scheduleKind: 'daycare',
					},
				],
			},
			{
				id: 'group_class',
				name: 'Quản lý lớp nhóm',
				icon: 'das--group',
				menu: 'group_class',
				isGuard: true,
				vIf: true,
				guard: ['leader', 'support', 'admin', 'org_admin', 'teacher'],
				state: ['activated', 'community', 'expired'],
				subs: [
					{
						id: 'group_classes',
						name: 'Lớp nhóm',
						icon: '',
						link: '/group-classes',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community', 'expired'],
						isGuard: true,
					},
					{
						id: 'group_class_plans',
						name: 'Kế hoạch nhóm',
						icon: '',
						link: '/group-class-plans',
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'community'],
						isGuard: true,
						vIf: true,
					},
					{
						id: 'report_group',
						name: 'Báo cáo nhóm',
						icon: '',
						link: '/report/group',
						isGuard: true,
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'expired'],
					},
					{
						id: 'schedule_group',
						name: 'Lịch học nhóm',
						icon: '',
						link: '/schedule/timeslot/group',
						isGuard: !!this.profile.exists_group_class,
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated'],
						scheduleKind: 'group',
					},
				],
			},
			{
				id: 'library',
				name: 'Thư viện',
				icon: 'das--library',
				menu: 'library',
				isGuard: true,
				vIf: true,
				guard: ['leader', 'support', 'admin', 'org_admin', 'teacher'],
				state: ['activated', 'community'],
				subs: [
					{
						id: 'goal_lib',
						name: 'Thư viện nội bộ',
						icon: '',
						link: '/goal-lib',
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'community'],
						isGuard: true,
						vIf: true,
					},
					{
						id: _ROUTER_NAME.GOAL_REFERENCE,
						name: 'Thư viện tham khảo',
						icon: '',
						link: '/goal-reference',
						guard: ['leader', 'support', 'admin', 'org_admin'],
						state: ['activated', 'community'],
						isGuard: true,
						vIf: true,
					},
				],
			},
			{
				id: 'luca_ai',
				name: 'Trợ lý AI',
				icon: 'das--ai',
				menu: 'luca_ai',
				isGuard: true,
				guard: ['leader', 'support', 'admin', 'org_admin', 'teacher'],
				state: ['activated', 'community', 'expired'],
				vIf: true,
				flag: this.flagCheckLucaAI(),
				subs: [
					{
						id: 'luca_ai_chat',
						name: 'Trò chuyện',
						icon: '',
						link: '/luca-ai-chat',
						isGuard: true,
						guard: [
							'leader',
							'support',
							'admin',
							'org_admin',
							'teacher',
						],
						state: ['activated', 'community', 'expired', 'locked'],
					},
					// {
					// 	id: 'luca_ai_statistic',
					// 	name: 'Thống kê',
					// 	icon: '',
					// 	link: '/luca-ai-chat/statistic',
					// 	isGuard: true,
					// 	guard: [
					// 		'leader',
					// 		'support',
					// 		'admin',
					// 		'org_admin',
					// 		'accountant',
					// 		'teacher',
					// 	],
					// 	state: ['activated', 'community', 'expired', 'locked'],
					// }
				],
			},
			{
				id: 'setup_information',
				name: 'Thiết lập cơ sở',
				icon: 'das--setting',
				menu: 'setup_information',
				link: '/setup-center',
				guard: ['leader', 'support', 'admin', 'org_admin'],
				isGuard: true,
				state: ['activated', 'community'],
				vIf: true,
			},
		];
	}

	get secondMenu() {
		return [];
	}

	get profile() {
		return this.setup.store.state.profile;
	}

	get hasStudentsNeedGeneratePeriodReport() {
		return this.setup.store.state.hasStudentsNeedGeneratePeriodReport;
	}

	get isCenterExpiredOrLocked() {
		return ['expired', 'locked'].includes(this.centerState);
	}

	get centerState() {
		return this.setup.store.state.profile.center_state;
	}

	get org_setting() {
		return this.setup.store.state.profile.current_org;
	}

	get isShowHTCS() {
		return ['leader', 'support', 'accountant'].includes(
			this.setup.store.state.profile.staff.role
		);
	}

	get menuCode() {
		return this.$route.meta.menu;
	}

	canShowMenuItem(item) {
		if (!item?.isGuard) return false;
		if (item.flag === false) return false;
		if (item.guard && !item.guard.includes(this.profile?.staff?.role)) {
			return false;
		}
		return true;
	}

	isLiteLockedMenu(item) {
		if (!isLitePackage(this.profile) || !item?.link) return false;
		const [path, queryString] = item.link.split('?');
		const query = {};
		if (queryString) {
			queryString.split('&').forEach((part) => {
				const [key, value] = part.split('=');
				if (key) query[key] = value;
			});
		}
		return !!getLiteLockedFeature(path, query);
	}

	visibleSubs(item) {
		if (!item?.subs) return [];
		return item.subs.filter((sub) => {
			if (!this.canShowMenuItem(sub)) return false;
			if (item.id === 'home' || item.id === 'personal') return true;
			return !this.isLiteLockedMenu(sub);
		});
	}

	isMenuGroupLocked(item) {
		if (!isLitePackage(this.profile) || !item?.subs?.length) return false;
		const linked = item.subs.filter((sub) => sub.link);
		return (
			linked.length > 0 &&
			linked.every((sub) => this.isLiteLockedMenu(sub))
		);
	}

	liteLockedTarget(item) {
		const role = this.profile?.staff?.role;
		const subs = item?.subs || [];
		const forRole = subs.find(
			(sub) => sub.link && (!sub.guard || sub.guard.includes(role))
		);
		return (forRole || subs.find((sub) => sub.link))?.link || '';
	}

	menuItemLink(item) {
		if (item?.link) return item.link;
		if (!this.isMenuGroupLocked(item)) return '';
		return this.liteLockedTarget(item);
	}

	scheduleMenuActive(kind) {
		return isScheduleMenuActive(kind, this.$route);
	}

	menuItemMatchesRoute(item) {
		if (item?.scheduleKind) {
			return this.scheduleMenuActive(item.scheduleKind);
		}
		if (!item?.link) return false;
		return item.link === this.isSubActive;
	}

	menuMatchesPath(menu) {
		return menu.subs?.some((sub) => this.menuItemMatchesRoute(sub));
	}

	syncOpenMenus() {
		const path = this.$route.path;
		if (!path) return;
		this.isSubActive = path.toString();
		[...this.menu, ...this.secondMenu].forEach((menu) => {
			if (!this.menuMatchesPath(menu)) return;
			this.isSubOpen = menu.id;
			this.collapsedSubs = this.collapsedSubs.filter(
				(id) => id !== menu.id
			);
		});
	}

	flagCheckLucaAI() {
		return FLAG_CHECK('LUCA_AI_CHAT');
	}

	flagCheckSurvey() {
		return FLAG_CHECK('SURVEY_QUESTIONNAIRE');
	}

	get languages() {
		return [
			{
				flag: 'vni',
				name: 'VNI',
			},
			{
				flag: 'eng',
				name: 'ENG',
			},
		];
	}

	mounted() {
		this.syncOpenMenus();
		this.onTutorialSpotlight(this.setup.tutorialSpotlightTarget);
		if (localStorage.getItem('lg') == 'vni') {
			this.language = this.languages[0];
		} else this.language = this.languages[1];
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//

	@Watch('$route')
	onRouteChange() {
		this.syncOpenMenus();
		this.onTutorialSpotlight(this.setup.tutorialSpotlightTarget);
	}

	@Watch('setup.tutorialSpotlightTarget', { immediate: true })
	onTutorialSpotlight(targetId) {
		if (
			targetId === 'tour-menu-record' ||
			targetId === 'tour-menu-record_student' ||
			targetId === 'tour-menu-record_employee'
		) {
			this.isSubOpen = 'record';
			this.collapsedSubs = this.collapsedSubs.filter(
				(id) => id !== 'record'
			);
		}
		if (targetId === 'tour-menu-plans_data') {
			this.isSubOpen = 'personal';
			this.collapsedSubs = this.collapsedSubs.filter(
				(id) => id !== 'personal'
			);
		}
	}

	subOpen(key) {
		const allMenus = [...this.menu, ...this.secondMenu];
		const item = allMenus.find((m) => m.id === key);
		const isExpanded = item
			? this.isSubExpanded(item)
			: this.isSubOpen === key;

		if (isExpanded) {
			this.isSubOpen = '';
			if (!this.collapsedSubs.includes(key)) {
				this.collapsedSubs.push(key);
			}
		} else {
			this.isSubOpen = key;
			this.collapsedSubs = this.collapsedSubs.filter((id) => id !== key);
		}
	}

	onMenuItemClick(item) {
		if (this.isMenuGroupLocked(item)) return;

		const tutorial = useTutorial();
		const inStudentTour =
			tutorial.phase.value === 'tour' &&
			tutorial.activeTask.value?.key === 'add_student';

		if (inStudentTour && item.id === 'record') {
			this.isSubOpen = 'record';
			this.collapsedSubs = this.collapsedSubs.filter(
				(id) => id !== 'record'
			);
			if (
				tutorial.activeSpotlight.value?.targetId === 'tour-menu-record'
			) {
				tutorial.setSpotlightByTarget('tour-menu-record_student');
			}
			return;
		}

		if (
			tutorial.phase.value === 'tour' &&
			(tutorial.activeTask.value?.key === 'edit_plan_with_ai' ||
				tutorial.activeTask.value?.key === 'edit_goal_library') &&
			item.id === 'personal'
		) {
			this.isSubOpen = 'personal';
			this.collapsedSubs = this.collapsedSubs.filter(
				(id) => id !== 'personal'
			);
			return;
		}

		this.subOpen(item.id);
	}

	onSubMenuClick(sub) {
		const tutorial = useTutorial();
		if (
			tutorial.phase.value === 'tour' &&
			tutorial.activeTask.value?.key === 'add_student' &&
			sub.id === 'record_student'
		) {
			tutorial.setSpotlightByTarget('add-student-btn');
		}
		if (
			tutorial.phase.value === 'tour' &&
			tutorial.activeTask.value?.key === 'staff_invitation' &&
			sub.id === 'record_employee'
		) {
			tutorial.setSpotlightByTarget('add-employee-btn');
		}
		if (
			tutorial.phase.value === 'tour' &&
			(tutorial.activeTask.value?.key === 'edit_plan_with_ai' ||
				tutorial.activeTask.value?.key === 'edit_goal_library') &&
			sub.id === 'plans_data'
		) {
			tutorial.setSpotlightByTarget('tutorial-virtual-student-row');
		}
	}

	isTutorialForcedMenu(menuId) {
		const tutorial = useTutorial();
		if (tutorial.phase.value !== 'tour') return false;
		const targetId = tutorial.activeSpotlight.value?.targetId;
		if (!targetId) return false;
		if (
			menuId === 'record' &&
			(targetId === 'tour-menu-record' ||
				targetId === 'tour-menu-record_student' ||
				targetId === 'tour-menu-record_employee')
		) {
			return true;
		}
		if (menuId === 'personal' && targetId === 'tour-menu-plans_data') {
			return true;
		}
		return false;
	}

	isSubExpanded(item) {
		if (this.isTutorialForcedMenu(item.id)) return true;
		if (this.collapsedSubs.includes(item.id)) return false;
		return this.isSubOpen === item.id || this.haveSub(item.subs);
	}

	haveSub(array) {
		if (!Array.isArray(array) || !this.isSubActive) return false;
		return array.some(
			(item) =>
				this.menuItemMatchesRoute(item) || this.haveSub(item?.subs)
		);
	}

	checkState(array) {
		if (!array) {
			return null;
		}
		if (!array.includes(this.centerState)) return true;
		else return false;
	}

	changeLanguage(data) {
		this.language = data;
		localStorage.setItem('lg', data.flag);
	}
}
</script>

<style lang="scss" scoped>
.side-menu--active {
	@apply bg-yellow-100 text-yellow-700;
	border-right: 2px solid #f0bb4f;
}

.side-menu--active-s {
	@apply bg-yellow-100 text-yellow-700;
}

.arrow--icon-menu {
	transition: all 0.4s ease;
}

.select-block {
	position: absolute;
	bottom: -65px;
	border: 1px solid #f9e3b7;
	width: 102px;
	border-radius: 6px;
	box-shadow: 0px 10px 16px 0px #14253f0f;
}
.grey-out {
	background: #f1f5f9 !important;
	color: #cbd5e1 !important;
}
</style>
